import { useEffect, useState } from "react";
import DataTableCommon from "../../Templates/DataTable/DataTableCommon";
import CutiColumns from "../constants/CutiColumns";
import { convertIdUserToNama, filterCutiBySearch } from "../utils";

const ListDaftarCuti = ({
  resetState,
  data,
  resetPaginationToggle,
  getSubHeaderComponent,
  searchFilter,
  pending,
}) => {
  const [filteredData, setFilteredData] = useState(data?.cuti || []);

  useEffect(() => {
    let newList = data?.cuti;
    newList = convertIdUserToNama(newList, data.staf);
    newList = filterCutiBySearch(newList, searchFilter);
    setFilteredData(newList);
  }, [data, searchFilter]);

  return (
    <DataTableCommon
      columns={CutiColumns(resetState, data)}
      data={filteredData}
      paginationResetDefaultPage={resetPaginationToggle}
      subHeaderComponent={getSubHeaderComponent()}
      progressPending={pending}
    />
  );
};

export default ListDaftarCuti;
